import api from "../../api";
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    customerNote: [],

  },
  getters: {
    getCustomerNote(state) {
      return state.customerNote;
    }
  },
  mutations: {
    SetCustomerNote(state, data) {
      state.customerNote = [];
      state.customerNote = data;
    }
  },
  actions: {
    getCoustomerNotes({ commit },data) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `customerNotes/getCoustomerNotes`,
            data,
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);

            commit("SetCustomerNote", res.data);
          })
          .catch((err) => console.log(err));
      });
    },

    addCoustomerNotes({ }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `customerNotes/addCoustomerNotes`,
            data,
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },
    editCoustomerNotes({ }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `customerNotes/editCoustomerNotes`,
            data,
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },





  },
};
